import { render, staticRenderFns } from "./ScaleVM.vue?vue&type=template&id=0c86070e&scoped=true&"
import script from "./ScaleVM.vue?vue&type=script&lang=js&"
export * from "./ScaleVM.vue?vue&type=script&lang=js&"
import style0 from "./ScaleVM.vue?vue&type=style&index=0&id=0c86070e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86070e",
  null
  
)

export default component.exports